
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate",
      function () {
        return require("private-next-pages/candidate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate"])
      });
    }
  